import React from 'react';
import Style from './formPreview.module.css';
import { InputLabel, InputSublabel, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import UploadFileZone from '../../../components/upload/uploadFileZone';
import useAppContext from '../../../context/useAppContext';
import { getWeezFileUrl } from '../../../components/upload/utils';

const FIELD_ID_PHOTO = 'ws-46';
const RATIO_ID_PHOTO = 7 / 9;

export default function FormImage({ field, label, value = null, id = null, onChangeForm = () => {} }) {
    const toast = React.useContext(ToastContext);
    const [{ organization }] = useAppContext();
    const { t } = useTranslation();

    const onChange = React.useCallback(
        v => {
            if (id) {
                onChangeForm(id, v);
            }
        },
        [id]
    );

    const imgUrl = React.useMemo(() => {
        return getWeezFileUrl(value, window.weezConfig.aws.weez_bucket_form);
    }, [value]);

    const onError = React.useCallback(e => {
        toast.error(t('nacre.previewFile.error.loading'));
        console.error(e);
    });

    return (
        <div className={Style['field']}>
            <UploadFileZone
                organization={organization}
                className={Style['form-image__upload-zone']}
                onUpload={image => onChange(image.url)}
                onError={onError}
                title={<InputLabel label={label} required={field.required} />}
                subtitle={field.form_field.description && <InputSublabel label={field.form_field.description} />}
                labelDropzone={t('ticket.event.dropzone_label')}
                subLabelDropzone={t('ticket.event.dropzone_label_min_size')}
                maxSize={2097152}
                file={imgUrl}
                onDelete={() => onChange(null)}
                cropModalProps={{
                    ratio: id === FIELD_ID_PHOTO ? RATIO_ID_PHOTO : null,
                    forceRatio: id === FIELD_ID_PHOTO
                }}
            />
        </div>
    );
}
